exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".col-center[data-v-400b608c]{text-align:center}.invoice-row .el-col i[data-v-400b608c]{margin-top:10px;font-size:20px!important}.invoice-row .el-col[data-v-400b608c]{line-height:40px;text-align:center}", "", {"version":3,"sources":["/workspace/src/views/payment-manager-new/pages/PaymentManagerForm.vue"],"names":[],"mappings":"AACA,6BAA6B,iBAAiB,CAC7C,AACD,wCAAwC,gBAAgB,wBAAyB,CAChF,AACD,sCAAsC,iBAAiB,iBAAiB,CACvE","file":"PaymentManagerForm.vue","sourcesContent":["\n.col-center[data-v-400b608c]{text-align:center\n}\n.invoice-row .el-col i[data-v-400b608c]{margin-top:10px;font-size:20px !important\n}\n.invoice-row .el-col[data-v-400b608c]{line-height:40px;text-align:center\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-400b608c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/payment-manager-new/pages/PaymentManagerForm.vue
// module id = 4942
// module chunks = 13